module.exports = __webpack_public_path__ + "img/cent-dining-benefits.83086f50.jpg";